<template>
	<div class="container">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>档案管理</el-breadcrumb-item>
			<el-breadcrumb-item>从属表管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索："  v-if="user.username == 'admin'">
      	<el-select size="small" v-model="departmentId" placeholder="请选择部门" @change="changeDept">
      	   <el-option v-for="item in departmentList"  :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
      	</el-select>
      </el-form-item>
      <el-form-item  >
        <el-select v-model="jzId"   placeholder="请选择用能单元" size="small" filterable  @change="changeSearchTer">
            <el-option
              v-for="item in terminalData"
              :key="item.id"
              :label="item.terminalName"
              :value="item.terminalCode">
            </el-option>
          </el-select>
      </el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" :disabled="!jzId" @click="handleEdit()">新增主表</el-button>
        <el-button size="small" type="primary"  @click="getPData()">搜索</el-button>
			</el-form-item>
		</el-form>

      <!-- 数据列表 -->
    <el-table size="small" row-key="id" :data="dataList"
       v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="meterInfoName" label="主表名称">
        </el-table-column>
        <el-table-column prop="terminalName" label="所属单元">
        </el-table-column>
        <el-table-column prop="areaName" label="所属区域">
        </el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="showChild(scope.row)">查看字表</el-button>

            <el-button size="mini" type="danger" @click="deleteGs(scope.row)">解除 </el-button>
          </template>
        </el-table-column>
      </el-table>




    <!-- 添加主表界面 -->
    <el-dialog  title="新增主表"  :visible.sync="addFormVisible" width="50%" @click='addFormVisible = false' @close="closeAddForm">

      <el-form :inline="true" :model="formInline" class="user-search">


        <el-form-item  >
          <el-input size="small" v-model="dataForm.meterInfoName" placeholder="请输入计量点名称"></el-input>
        </el-form-item>
      	<el-form-item>

          <el-button size="small" type="primary"  @click="getAddMdata()">搜索</el-button>
      	</el-form-item>
      </el-form>


    	<el-table class="zhubiao" size="small" :data="meterList" height="500px"  highlight-current-row   @current-change="handleSelectionChange"  ref='bindTable'
    	 v-loading="loadMeter">
    		<!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column type="index" ></el-table-column>

    		<el-table-column label="计量点名称" prop="meterInfoName"></el-table-column>
    		<el-table-column label="所属单元" prop="terminalName" ></el-table-column>
        <el-table-column label="所属区域" prop="areaName"></el-table-column>
    	</el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='addFormVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="addMeters()">确认</el-button>
    	</div>
    </el-dialog>



    <!-- 查看子表 -->
    <el-dialog  title="查看子表"  :visible.sync="subFrom" width="60%" @click='subFrom = false' @close="childClose">
    	<!-- <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input> -->
      <div  style="margin-bottom: 20px;" >
        <el-button size="small" type="primary" @click="setChild">新增子表</el-button>
        <el-button type="danger" @click="deleteChild()" size="small">解除</el-button>
      </div>
      <div class="stepBox">
        <div class="stepItem" v-for="(item,idx) in breadList" @click="getChildDataByIdx(item,idx)">
          {{item.meterInfoName}}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    	<el-table size="small" :data="subList" border height="500px" @selection-change="cchange"  ref='bindTable'
    	 v-loading="loadMeter">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterInfoName">
        </el-table-column>
        <el-table-column prop="terminalName" label="所属单元">
        </el-table-column>
        <el-table-column prop="areaName" label="所属区域">
        </el-table-column>
    		<el-table-column label="操作" center width="180">
          <template slot-scope="scope">
          <!--  <el-button type="primary"  @click="setChild(scope.row)" size="small">新增子表</el-button> -->
            <el-button size="mini" @click="showChild(scope.row)">查看字表</el-button>
            <!-- <el-button type="danger" @click="deleteGs(scope.row,true)" size="small">解除</el-button> -->
          </template>
        </el-table-column>

    	</el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='subFrom = false'>取消</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveChild()">确认</el-button> -->
    	</div>
    </el-dialog>

    <!-- 添加子表界面 -->
    <el-dialog  title="新增子表"  :visible.sync="setFrom" width="50%" @click='addFormVisible = false' @close="closeSetForm">
    	<el-form :inline="true" :model="formInline" class="user-search">

    	  <el-form-item  >
    	    <el-select v-model="addDataFrom.terminalCode"   placeholder="请选择用能单元" size="small" filterable >
    	        <el-option
    	          v-for="item in tempTerList"
    	          :key="item.id"
    	          :label="item.terminalName"
    	          :value="item.terminalCode">
    	        </el-option>
    	      </el-select>
    	  </el-form-item>
        <el-form-item  >
          <el-input size="small" v-model="addDataFrom.meterInfoName" placeholder="请输入计量点名称"></el-input>

        </el-form-item>
    		<el-form-item>

    	    <el-button size="small" type="primary"  @click="getAddMetrData()">搜索</el-button>
    		</el-form-item>
    	</el-form>

    	<el-table size="small" :data="setChildList" height="500px" @selection-change="handChildChange"  ref='bindTable'
    	 v-loading="loadMeter">
    		<el-table-column type="selection"></el-table-column>
        <el-table-column type="index" ></el-table-column>
    		<!-- <el-table-column label="id" prop="id" width="100"></el-table-column> -->
    		<el-table-column label="计量点名称" prop="meterInfoName">

        </el-table-column>
    		<el-table-column label="所属单元" prop="terminalName" width="200"></el-table-column>
         <el-table-column label="所属区域" prop="areaName"></el-table-column>
        <el-table-column label="是否绑定主表" prop="terminalInfoName" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.parentId > 0" size="mini" type="danger">是</el-tag>
            <el-tag v-else size="mini" >否</el-tag>
          </template>
        </el-table-column>
    	</el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='setFrom = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveChild()">确认</el-button>
    	</div>
    </el-dialog>




	</div>
</template>

<script>
  import {
      getDepartmentTerminalInfoLis,
      getEnergyTypeList,
      getTerminalInfoByDepId,
      getTerminalInfoList,
      findMeterInfoList,
      updateMeterInfoToMain,
      getMainMeterInfoDataByCode,
      getIsHaveMainMeterInfoDataByCode,
      getMeterInfoDataByParentId,
      updateMeterInfoMainAndSonRelation,
      removeMeterInfoToRelation,
      findParentSonMeterList,
  } from '../../api/energyMG'
  import { getNyfx,addFx,getGs,addFormula,delFormula,getMeterList,saveEnergyDataItem} from '../../api/analysisMG'

	export default {
		data() {
			return {
        subFrom:false,
        setFrom:false,
        setChildList:[],
        subList:[],
        breadList:[],
        terminalCode:"",
        jzId:"",
        meterId:'',
        addFormVisible:false,
        saveLoad:false,
        setLoading:false,
        loadMeter:false,
        searchDatas:"",
        visible:false,
				dataList: [],
        user:{},
        pid:"",
        treeLoad:false,
        departmentId:"",
				tempTerList: [],
        meterList:[],
        getJZ:"",
				loading: false,
        editGs:false,
				formInline: {},
				depLoading:false,
				jzProps: {
					children: 'deps',
				},
        yongTuForm:{
          energyName:""
        },
        typePurpose:[],
				nyTitle:'新增',
				editNyuanFromVisible:false,
				energyData:[],
        departmentList:[],
        meterInfoListTemp:[],
				eneryType:"",
        fxIds:'',
        gs:'',
        editData:[],
        energyName:"",
        energyFx:"",
        loadE:false,
        meterIds:"",
        curPid:'',
        eid:"",
        treeLoad:false,
        getJZ:"",
        treeDate:[],
        choisData:[],
        MeterInfoList:[],

        energy_type:"",
        tempAddMeterList:[],
        tempDelMeterList:[],
        jzProps:{
        	label: function( data,node ){
        		//console.log(data)
        	},
        	children: 'deps',
        },
        dataForm:{
          depId:"",
          meterId:"",
          terminalCode:"",
          meterInfoName:""
        },
        addDataFrom:{
          depId:"",
          meterId:"",
          terminalCode:"",
          conditions:1,
          meterInfoName:""
        },

        terId:'',
        curId:'',
        childId:'',
        dataParameter:{
        	terIds:JSON.stringify([]),
        	currentPage: 1,
        	pageSize: 9999,
        	meterPoint:'',
        	meterPointName:'',
        	energyType:'',
          isRunning:'',
        },
        cid:"",
        terminalData:[],
        showYongTu:false,
        meterIdsArr:[]
			}
		},
    computed: {
    	tables() {
    		let search = this.searchDatas
    		if (search) {
    			return this.MeterInfoList.filter(data => {
    				return Object.keys(data).some(key => {
    					return String(data[key]).toLowerCase().indexOf(search) > -1
    				})
    			})
    		}
    		return this.MeterInfoList
    	}
    },
		created() {
       this.user = JSON.parse(sessionStorage.getItem('userdata'))

       this.getJzData()
		},

		methods: {

      closeSetForm(){
        this.addDataFrom.meterInfoName = ''
      },
      closeAddForm(){
        this.dataForm.meterInfoName = ''
        console.log( this.dataForm.meterInfoName)
      },
      changeSearchTer(e){
        this.dataForm.terminalCode = e
        console.log(e)
        console.log(this.dataForm)
      },

      handleEdit(){
      	this.addFormVisible = true

        this.getAddMdata()
      },

      // 获取新增主表数据
      getAddMdata(){
        this.dataForm.conditions = 2
        findParentSonMeterList(this.dataForm).then(res => {
          this.loading = false
          if(res.status == 1){
            this.meterList = res.data.data
          }
        })
      },


      //获取一级主表
      getPData(){
        this.loading = true
        this.dataForm.meterId = ""
        this.dataForm.conditions = ""
        findParentSonMeterList(this.dataForm).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
          }
        })
      },

      //获取子表
      getChildData(){
        this.dataForm.conditions = ""
        findParentSonMeterList(this.dataForm ).then(res => {
          if(res.status == 1){
            this.subList = res.data.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      getChildDataByIdx(item,idx){
        if(idx != this.breadList.length-1){
          this.dataForm.meterId = item.meterId
          this.breadList.splice(idx+1,10)
          this.getChildData()
        }
      },

      childClose(){
        this.breadList = []
      },
      setChild(){
        this.setFrom = true
        this.loadMeter = true
        // let param = {
        //   terIds:JSON.stringify([{id:this.terId}]),
        //   currentPage: 1,
        //   pageSize: 9999,
        //   meterPoint:'',
        //   meterPointName:'',
        //   energyType:'',
        //   isRunning:'',
        // }
        // //
        // findMeterInfoList(param).then(res => {
        //   if(res.status == 1){
        //     this.setChildList = res.data.data
        //   }else{
        //     this.$message.error(res.msg)
        //   }
        // })
        this.getAddMetrData()
      },

      getAddMetrData(){
        findParentSonMeterList(this.addDataFrom ).then(res => {
           this.loadMeter = false
          if(res.status == 1){
            this.setChildList = res.data.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },




      handChildChange(e){

        this.childId = e.map(item => item.meterId).join('-')

      },

      cchange(e){
        this.cid = e.map(item => item.meterId).join('-')
      },


      showChild(row){
        this.subFrom = true
        this.pid = row.id
        this.cid = ''
        this.terId = row.terminalId
        this.curId  = row.meterId
        this.dataForm.meterId = row.meterId
        this.addDataFrom.terminalCode = row.terminalInfoCode

        this.tempTerList = this.departmentList.filter( item => item.id == this.departmentId)[0].terminalInfo



        this.breadList.push(row)
        this.getChildData()
      },


      saveChild(){
        let param = {
          parentId:this.curId,
          sonId:this.childId
        }


        console.log()
        this.setLoading = true
        updateMeterInfoMainAndSonRelation(param).then(res => {
           this.setLoading = false
           if(res.status == 1){
             this.$message.success('操作成功')

             this.setFrom = false
             this.getChildData()
           }else{
             this.$message.error(res.msg)
           }
        })
      },



      changeDept(){
        this.terminalData = this.departmentList.filter( item => item.id == this.departmentId)[0].terminalInfo
        this.dataForm.depId = this.departmentId
      },


      delMeter(){

        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( res => {
          this.saveFormula('delete')
        })

      },

      addMeters(){

        updateMeterInfoToMain({meterId:this.meterId}).then(res => {
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.addFormVisible = false
            this.dataForm.meterId = ''

            this.getPData()
          }else{
            this.$message.error(res.msg)
          }
        })

      },

     //获取集中器信息
     getJzData: function() {
     	return new Promise((resolve, reject) => {
     		getDepartmentTerminalInfoLis().then(res => {
     			this.treeLoad = false
     			if (res.status == 1) {
             this.departmentList = res.data.menuDepList
             this.departmentId = res.data.menuDepList[0].id


             this.dataForm.depId = this.departmentId
             this.terminalData = this.departmentList.filter( item => item.id == this.departmentId)[0].terminalInfo
             this.getPData()
     			} else {
     				this.$message.error(res.msg)
     			}
     		})
     	})
     },


      handleNodeClick(data) {
      	this.getJZ = data.departmentName
        this.energyFrom.terminalCode = data.terminalCode
        this.visible = false
      },

      getEnergy() {
        getEnergyTypeList().then(res => {
          if(res.status == 1){
            this.typeList = res.data.dataList
          }
        })
      },


      getEnergyTypeConfigList(){
        if( this.user.username != 'admin'){
          this.departmentId = this.user.departmentId
        }
        let param = {
          departmentId:this.departmentId
        }
        this.loading = true

      },



      getMeters(){
        this.dataParameter.terIds = JSON.stringify([{id:this.jzId}])

        findMeterInfoList(this.dataParameter).then(res => {
          if(res.status == 1){
            this.meterList = res.data.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      selectRow(e){

        this.$refs.bindTable.clearSelection()
        this.$refs.bindTable.toggleRowSelection(e.pop())

        this.meterId = e.pop().id
      },
			handleSelectionChange(e){

        this.meterId = e.meterId
        this.$refs.bindTable.clearSelection()
        this.$refs.bindTable.toggleRowSelection(e)
      },

      // handleRowClick( row,clumn,event){
      //   console.log(row)
      //   this.$refs.bindTable.toggleRowSelection(row)
      // },

      //保存分项
      saveFx(){

        if(this.eneryType == '' ){
          this.$message.info('请选择能源类型')
          return
        }
        if(this.fxIds == ''){
          this.$message.info('请选择能源用途')
          return
        }
        this.saveLoad = true
        let param = {
          departmentId:this.departmentId,
          energyTypeId:this.eneryType,
          energyDataId:this.fxIds
        }
        addFx(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.getEnergyTypeConfigList()
            this.editNyuanFromVisible = false
          }else{
            this.$message.error(res.msg)
          }
        })
      },



      showNoBindMters(){
        this.addFormVisible = true
        this.getJZ = ''
        this.energyFrom.terminalCode = ""
        this.energyFrom.isEnergyData = ""
        this.energyFrom.meterName = ""

        this.getMeterList();
      },

      //获取计量点
      getMeterList(){
        this.energyFrom.departmentId = this.department_id
        this.energyFrom.energyType = this.energy_type
        this.loadMeter = true

        getMeterList( this.energyFrom ).then( res => {
          this.loadMeter = false
          if(res.status == 1 ){
            this.MeterInfoList = res.data.dataList
          }

        })
      },


      setMeterChoise(e){
        this.writeGs()
        this.tempDelMeterList = e.map(item => item.id)
      },



      saveFormula(isDelete){
        this.saveLoad = true
        this.meterIds = this.choisData.map(item => item.id).join('-')
        let param = {
          meterInfoId:isDelete ? this.tempDelMeterList.join('-'):this.meterIds,
          energyId:isDelete ? '' : this.eId
        }

        addFormula(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){

             this.$message.success('操作成功！')
            let arr =[]
             if( isDelete ){
              this.choisData.forEach(item =>{
              	if (!(this.tempDelMeterList.indexOf(item.id) > -1)) {
              		arr.push(item)
              	}
              })
              this.choisData = arr
             }else{
               this.editGs = false
             }
          }else{
             this.$message.error('操作失败')
          }
        })
      },

      //删除主表
      deleteGs(row){
        let param ={
          meterId:row.meterId
        }

        this.$confirm('确定要解除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( ()=> {
          removeMeterInfoToRelation(param).then( res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getPData()
            }else{
              this.$message.error(res.msg)
            }
          })
        })

      },

      //删除子表
      deleteChild(){

        if(this.cid == ""){
          this.$message.error('请选择要删除的计量点')
          return
        }
        let param ={
          meterId:this.cid
        }

        this.$confirm('确定要解除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( ()=> {
          removeMeterInfoToRelation(param).then( res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getChildData()
            }else{
              this.$message.error(res.msg)
            }
          })
        })

      }
		}
	}
</script>

<style >

  .stepBox{
    margin-bottom: 20px;
    display: flex;
  }
  .zhubiao .el-table__body tr.current-row>td{
    background: #79bbff;
  }
  .stepItem{
    display: flex;
    cursor: pointer;
    margin-right: 10px;
    line-height: 14px;
  }
  .stepItem:hover{
    color: #409EFF;
  }

	.treel{
		padding: 0 20px;
		font-size: 13px;
	}
  .gs{
    height: 100px;
  }
	.treel i{
		font-size: 14px;
	}
	.treel /deep/ .el-tree-node{
		white-space: normal !important;
	}
	.treel /deep/ .el-tree-node__content{
		height: auto;
		padding: 6px 0;
	}


</style>



// WEBPACK FOOTER //
// src/views/archives/pc.vue